import { RecipeVariants } from '@/style/utils/createRecipeObj';
import { createUseRecipeHook } from '@/style/utils/createUseRecipeHook';
import * as style from './Container.css';

export const useContainerStyle = createUseRecipeHook(style.root);
export type ContainerStyleProps = RecipeVariants<typeof style.root>;
